// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import React, { useContext } from 'react';
import generatedIcons from '../icon/generated/icons';
import { InternalComponentIconsContext, InternalIconContext } from './context';
function InternalIconProvider({ children, icons, componentIcons }) {
    const contextIcons = useContext(InternalIconContext);
    const contextComponentIcons = useContext(InternalComponentIconsContext);
    let iconsToProvide = generatedIcons;
    // Merge the context icons with the custom icons, this allows child instances of IconProvider to persist parent configurations
    if (icons !== null) {
        const clonedIcons = { ...icons };
        // Reset null icon values to their generated default, or the inherited context value for custom icons
        Object.keys(clonedIcons).forEach(name => {
            var _a;
            const iconName = name;
            if (clonedIcons[iconName] === null) {
                clonedIcons[iconName] = (_a = generatedIcons[iconName]) !== null && _a !== void 0 ? _a : contextIcons[iconName];
            }
        });
        iconsToProvide = { ...contextIcons, ...clonedIcons };
    }
    // Merge with inherited component icons, per component and per icon (closest provider wins).
    let componentIconsToProvide = contextComponentIcons;
    if (componentIcons === null) {
        componentIconsToProvide = {};
    }
    else if (componentIcons) {
        componentIconsToProvide = { ...contextComponentIcons };
        for (const name of Object.keys(componentIcons)) {
            const value = componentIcons[name];
            componentIconsToProvide[name] = value === null ? undefined : { ...contextComponentIcons[name], ...value };
        }
    }
    return (React.createElement(InternalIconContext.Provider, { value: iconsToProvide },
        React.createElement(InternalComponentIconsContext.Provider, { value: componentIconsToProvide }, children)));
}
export default InternalIconProvider;
//# sourceMappingURL=internal.js.map